// This file was generated with `npm run icons:generate`. Don’t edit directly.
import Icon from 'tailwind/components/Icon/Icon';
import type { MediumIconProps } from 'tailwind/components/Icon/Icon.types';

const UtilityStrokeArrowUpMediumIcon = (props: MediumIconProps) => (
  <Icon {...props} viewBox="0 0 32 32">
    <path
      d="M16.3484 5.65658C16.1531 5.46132 15.8365 5.46132 15.6413 5.65658L9.10482 12.193C8.90956 12.3883 8.90956 12.7049 9.10482 12.9001C9.30008 13.0954 9.61667 13.0954 9.81193 12.9001L15.4949 7.21718L15.4949 26.0517C15.4949 26.3278 15.7188 26.5517 15.9949 26.5517C16.271 26.5517 16.4949 26.3278 16.4949 26.0517L16.4949 7.2173L22.1777 12.9001C22.373 13.0954 22.6896 13.0954 22.8848 12.9001C23.0801 12.7049 23.0801 12.3883 22.8848 12.193L16.3484 5.65658Z"
      fill="currentcolor"
    />
  </Icon>
);

export default UtilityStrokeArrowUpMediumIcon;
